import { render, staticRenderFns } from "./TableColumnsSettings.vue?vue&type=template&id=c991262e&scoped=true"
import script from "./TableColumnsSettings.vue?vue&type=script&lang=js"
export * from "./TableColumnsSettings.vue?vue&type=script&lang=js"
import style0 from "./TableColumnsSettings.vue?vue&type=style&index=0&id=c991262e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c991262e",
  null
  
)

export default component.exports